var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{class:[
    _vm.$style.wrapper,
    _vm.isOverseas && _vm.$style.overseasVersion,
    _vm.collapse && _vm.$style.collapse
  ]},[(!_vm.isOverseas)?_c('SceneGuide',{class:_vm.$style.item}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }